module.exports = __webpack_public_path__ + "media/how-it-works/reshop-b9b2a9fd.png";